import type { WeatherDto } from '@camper-diary/shared';
import { api } from './client';

export type Weather = WeatherDto;

export function getStageWeather(tripId: string, stageId: string) {
  return api<Weather | null>(
    `/trips/${encodeURIComponent(tripId)}/stages/${encodeURIComponent(stageId)}/weather`,
  );
}

export function refreshStageWeather(tripId: string, stageId: string) {
  return api<Weather | null>(
    `/trips/${encodeURIComponent(tripId)}/stages/${encodeURIComponent(stageId)}/weather/refresh`,
    { method: 'POST' },
  );
}
